import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { applyTheme, getChoice } from "@/lib/edition";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    // Skip while returning from Google; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);

  useEffect(() => { if (user !== null) applyTheme(user ? user.edition : getChoice()); }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const register = async (name, email, password, edition) => {
    const { data } = await api.post("/auth/register", { name, email, password, edition });
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    if (window.caches) await window.caches.delete("daybreak-api").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
